// /src/pages/JoinUsPage.jsx

import React, { useState, useRef } from 'react';
import ExclusiveTab from './publicTabs/ExclusiveTab';
import AffiliatedTab from './publicTabs/AffiliateTab';
import PublicTocPanel from '../components/PublicTocPanel';

function JoinUsPage() {
  const [currentTab, setCurrentTab] = useState('exclusive');
  const [forceRender, setForceRender] = useState(0);
  const [publicTocVisible, setPublicTocVisible] = useState(false);

  const tocState = useRef({
    showPublicToc: false,
    toc: [],
    tocVisible: false,
    setTocVisible: null,
    containerRef: null
  });

  const handleTocReady = (data) => {
    tocState.current = data;
    setForceRender(n => n + 1);
  };

  return (
    <div>
      <div className="title-container margin-top-spacer-60">
        <div 
          onClick={() => setCurrentTab('exclusive')} 
          className={`trapezoid-border4 ${currentTab === 'exclusive' ? 'active' : ''}`}
        >
          <a className="trapezoid-title">
            <span>Exclusive</span>
          </a>
        </div>
        <div 
          onClick={() => setCurrentTab('affiliated')} 
          className={`trapezoid-border3 ${currentTab === 'affiliated' ? 'active' : ''}`}
        >
          <a className="trapezoid-title">
            <span>Affiliated</span>
          </a>
        </div>
      </div>

      {/* TOC PANEL */}
        {tocState.current.showPublicToc && tocState.current.tocVisible && (
        <>
            <PublicTocPanel
                toc={tocState.current.toc}
                containerRef={tocState.current.containerRef}
                onClose={() => tocState.current.setTocVisible(false)}
            />
        </>
        )}

      <div className={`public-container glass-card ${publicTocVisible ? 'public-container-shifted' : ''}`}>
        {currentTab === 'exclusive'
          ? <ExclusiveTab onTocReady={handleTocReady} onTocVisibleChange={setPublicTocVisible} />
          : <AffiliatedTab onTocReady={handleTocReady} onTocVisibleChange={setPublicTocVisible} />
        }
      </div>
    </div>
  );
}

export default JoinUsPage;
